<template>
  <v-container>
    <v-row>
      <v-col cols='4' class='d-flex justify-start'>
        <v-btn small color='primary' @click='toggleSelected()'>
          <v-icon small left>mdi-swap-horizontal</v-icon>
          {{ this.selected_projects.length !== this.staging_projects.length ? "Select All Visible" : "Deselect All" }}
        </v-btn>
      </v-col>
      <v-col cols='4' class='d-flex justify-center'>
        <v-chip class='justify-center' small label width='200' :color='selected_projects.length ? "info" : ""'>
          {{ selected_projects.length + " projects selected" }}
        </v-chip>
      </v-col>
      <v-col cols='4' class='d-flex justify-end'>
        <v-btn small color='primary' :disabled='!selected_projects.length' :loading='processing'
          @click='processSelected()'>
          <v-icon small left>mdi-arrow-right-bold</v-icon>
          Process
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols='12'>
        <wc-data-box :title='table_title' :titleIcon='table_icon' :loading='is_loading' showHelp :helpText='helpText'
          helpWidth='900'>
          <template v-slot:middle_column>
            <v-select style='width: 20px; font-size: 14px;' class='mx-2 mb-n3' :items='[15, 50, 100, 250]'
              label="Per Page" dense v-model='number_per_page' @change='filterSearch()'></v-select>
          </template>
          <template v-slot:prependToolbarButtons>
            <div style='width: 200px;'>
              <v-text-field class='mx-2 mb-n3' dense width='0' v-model='search' @input='filterSearch()'></v-text-field>
            </div>
          </template>

          <staging-table-header style='margin-bottom: 0.5px solid lightgrey;' :table_title='table_title'
            table_icon='table_icon' :column_headers='column_headers' :length='length' :stats='stats'
            :disable_po_filter='disable_po_filter' :disable_meter_pits_filter='disable_meter_pits_filter'
            :disable_timeline_filter='disable_timeline_filter' :disable_commercial_filter='disable_commercial_filter'
            @filterOverdue='filterOverdue' @filterSpecificConflicts='filterSpecificConflicts'
            @filterConflicts='filterConflicts' @filterPreCheckRequired='filterPreCheckRequired'
            @filterQuickPay='filterQuickPay' @filterSnailMailOnly='filterSnailMailOnly'
            @filterNoConflicts='filterNoConflicts' @filterSeriousConflicts='filterSeriousConflicts'
            @filterColumnOne='filterColumnOne' @filterColumnTwo='filterColumnTwo' @filterColumnThree='filterColumnThree'
            @filterColumnFour='filterColumnFour' @filterColumnFive='filterColumnFive' @filterDeclined='filterDeclined'
            @filterInProgress='filterInProgress' @filterPO='filterPO' @filterTimeline='filterTimeline'
            @filterNewHomeowner="filterNewHomeowner" @filterSiteAddressMissing="filterSiteAddressMissing"
            @filterSiteCityMissing="filterSiteCityMissing" @filterSiteProvinceMissing="filterSiteProvinceMissing"
            @filterPostalCodeMissing="filterPostalCodeMissing" @filterRouteGroupMissing="filterRouteGroupMissing"
            @filterRouteNumberMissing="filterRouteNumberMissing" @filterProjectOnHold="filterProjectOnHold"
            @filterNoticeContactMissing="filterNoticeContactMissing"
            @filterMailingAddressMissing="filterMailingAddressMissing"
            @filterEmailAddressMissing="filterEmailAddressMissing"
            @filterNoticesContactArchive="filterNoticesContactArchive"
            @filterNoticesContactOnHold="filterNoticesContactOnHold"
            @filterBillingContactMissing="filterBillingContactMissing"
            @filterBillingAddressMissing="filterBillingAddressMissing"
            @filterBillingCityMissing="filterBillingCityMissing"
            @filterBillingProvinceMissing="filterBillingProvinceMissing"
            @filterBillingPostalMissing="filterBillingPostalMissing"
            @filterBillingContactArchived="filterBillingContactArchived"
            @filterBillingContactOnHold="filterBillingContactOnHold" @filterCommercial='filterCommercial'
            @filterMeterPits='filterMeterPits' @viewStagingProject='viewStagingProject' />
          <template v-for='(staging_project, index) in staging_projects'>
            <staging-row :ref='"row" + index' :key='staging_project.id' :staging_project='staging_project'
              @viewStagingProject='viewStagingProject' @select='selectRow'></staging-row>
          </template>
          <template>
            <div class="text-center" style="padding-top: 55px; padding-bottom: 25px;">
              <v-pagination v-model="page" :length="paginator_length" @input="changePage"></v-pagination>
            </div>
          </template>

        </wc-data-box>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import stagingAPI from '@/api/staging';
import Header from './table/Header';
import Row from './rows/Row';

export default {
  name: 'staging-table',
  data: () => ({
    selected_projects: [],
    filtered_projects: [],
    page: 1,
    number_per_page: 50,
    is_loading: false,
    processing: false,
    filter_specific_conflicts: "",
    filter_conflicts: false,
    filter_serious_conflicts: false,
    filter_no_conflicts: false,
    filter_pre_check_required: false,
    filter_snail_mail_only: false,
    filter_quickpay: false,
    filter_column_one: false,
    filter_column_two: false,
    filter_column_three: false,
    filter_column_four: false,
    filter_column_five: false,
    filter_declined: false,
    filter_in_progress: false,
    filter_commercial: false,
    filter_timeline: false,
    filter_new_homeowner: false,
    filter_site_address_missing: false,
    filter_site_city_missing: false,
    filter_site_province_missing: false,
    filter_postal_code_missing: false,
    filter_route_group_missing: false,
    filter_route_number_missing: false,
    filter_project_on_hold_missing: false,
    filter_notice_contact_missing: false,
    filter_mailing_address_missing: false,
    filter_email_address_missing: false,
    filter_notices_contact_archive: false,
    filter_billing_contact_missing: false,
    filter_billing_address_missing: false,
    filter_billing_city_missing: false,
    filter_billing_province_missing: false,
    filter_billing_postal_missing: false,
    filter_billing_contact_archived: false,
    filter_billing_contact_on_hold: false,
    filter_po: false,
    filter_meter_pits: false,
    filter_overdue: false,
    filter_search: false,
    search: "",
    helpText: "<ol>" +
      "<li><b>Fix Conflicts</b>" +
      "<p>Projects with conflicts or that require pre-check cannot be selected/processed/moved." +
      "<br>Click on the project name to view conflicts<br>Projects can be opened into a new window from the quickview dialog</p>" +
      "<p>These projects can still be set to cancelled, but otherwise cannot advance through staging</p></li>" +
      "<li><b>Select projects either individually (project checkbox), or as a group (location column checkbox)</b></li>" +
      "<p>Projects that have conflicts, are cancelled, or have completed staging cannot be selected for processing/move<br>" +
      "Cancelled projects need to be un-cancelled individually. Click on a project to open Quickview where you can un-cancel it if needed.<br>" +
      "<i>&nbsp Additional Project info can be changed within the quickview window. (you can also preview it's pending notice, if applicable)</i></p>" +
      "<li><b>Click the Process (or Move) button</b>" +
      "<p>The process action will advance each selected project to the next location (moving from left to right across the columns) after completing the associated action (ussually sending an email).</p>" +
      "<p>If projects are selected and manually moved to a location using the move button, any actions associated with the locations it is leaving and/or moving over will NOT be taken.</p>" +
      "<i> This will prevent the group from moving to that location.</i></p></li></ol><br>" +
      "<ul><li>To view projects from a single location, click the funnel icon at the top right of the column</li>" +
      "<li>Please see the top right burger menu for additional project row information</li>" +
      "<li>Currently, you can only have one filter active at a time.</li></ul>"
  }),
  props: {
    table_title: {
      required: true,
      type: String
    },
    table_icon: {
      required: true,
      type: String
    },
    staging_projects: {
      required: true,
      type: Array
    },
    stats: {
      required: true,
      type: Object
    },
    disable_timeline_filter: {
      required: false,
      type: Boolean,
      default: false,
    },
    disable_commercial_filter: {
      required: false,
      type: Boolean,
      default: false,
    },
    disable_meter_pits_filter: {
      required: false,
      type: Boolean,
      default: false
    },
    disable_po_filter: {
      required: false,
      type: Boolean,
      default: false
    },
    length: {
      required: true,
      type: Number
    },
    column_headers: {
      required: true,
      type: Array
    }
  },
  computed: {
    paginator_length() {
      if (this.length === 0 || this.length <= this.number_per_page) {
        return 1;
      }
      return Math.ceil(this.length / this.number_per_page);
    },
    get_filters() {
      const filters = {};
      filters['filter_specific_conflicts'] = this.filter_specific_conflicts;
      filters['filter_no_conflicts'] = this.filter_no_conflicts;
      filters['filter_conflicts'] = this.filter_conflicts;
      filters['filter_serious_conflicts'] = this.filter_serious_conflicts;
      filters['pre_check_required'] = this.filter_pre_check_required;
      filters['is_quickpay'] = this.filter_quickpay;
      filters['snail_mail_only'] = this.filter_snail_mail_only;
      filters['filter_column_one'] = this.filter_column_one;
      filters['filter_column_two'] = this.filter_column_two;
      filters['filter_column_three'] = this.filter_column_three;
      filters['filter_column_four'] = this.filter_column_four;
      filters['filter_column_five'] = this.filter_column_five;
      filters['filter_declined'] = this.filter_declined;
      filters['filter_in_progress'] = this.filter_in_progress;
      filters['filter_commercial'] = this.filter_commercial;
      filters['filter_po'] = this.filter_po;
      filters['has_meter_pits'] = this.filter_meter_pits;
      filters['filter_overdue'] = this.filter_overdue;
      filters['filter_timeline'] = this.filter_timeline;
      filters['search'] = this.search;
      filters['number_per_page'] = this.number_per_page;
      return filters;
    }
  },
  methods: {
    filter() {
      this.deselectAll();
      this.selected_projects = [];
      this.$emit('filter', this.page, this.get_filters);
    },
    filterSpecificConflicts(filter) {
console.log("filter specific")
      this.page = 1;
      this.filter_specific_conflicts = filter;
      this.filter();
    },
    filterOverdue(filter) {
      this.page = 1;
      this.filter_overdue = filter;
      this.filter();
    },
    filterConflicts(filter) {
      this.filter_conflicts = filter;
      this.page = 1;
      this.filter();
    },
    filterNoConflicts(filter) {
      this.filter_no_conflicts = filter;
      this.page = 1;
      this.filter();
    },
    filterPreCheckRequired(filter) {
      this.filter_pre_check_required = filter;
      this.page = 1;
      this.filter();
    },
    filterQuickPay(filter) {
      this.filter_quickpay = filter;
      this.page = 1;
      this.filter();
    },
    filterSnailMailOnly(filter) {
      this.filter_snail_mail_only = filter;
      this.page = 1;
      this.filter();
    },
    filterSeriousConflicts(filter) {
      this.filter_serious_conflicts = filter;
      this.page = 1;
      this.filter();
    },
    filterColumnOne(filter) {
      this.filter_column_one = filter;
      this.page = 1;
      this.filter();
    },
    filterColumnTwo(filter) {
      this.filter_column_two = filter;
      this.page = 1;
      this.filter();
    },
    filterColumnThree(filter) {
      this.filter_column_three = filter;
      this.page = 1;
      this.filter();
    },
    filterColumnFour(filter) {
      this.filter_column_four = filter;
      this.page = 1;
      this.filter();
    },
    filterColumnFive(filter) {
      this.filter_column_five = filter;
      this.page = 1;
      this.filter();
    },
    filterDeclined(filter) {
      this.filter_declined = filter;
      this.page = 1;
      this.filter();
    },
    filterInProgress(filter) {
      this.filter_in_progress = filter;
      this.page = 1;
      this.filter();
    },
    filterMeterPits(filter) {
      this.filter_meter_pits = filter;
      this.page = 1;
      this.filter();
    },
    filterPO(filter) {
      this.filter_po = filter;
      this.page = 1;
      this.filter();
    },
    filterCommercial(filter) {
      this.filter_commercial = filter;
      this.page = 1;
      this.filter();
    },
    filterTimeline(filter) {
      this.filter_timeline = filter;
      this.page = 1;
      this.filter();
    },
    filterNewHomeowner(filter) {
      this.filter_new_homeowner = filter;
      this.page = 1;
      this.filter();
    },
    filterSiteAddressMissing(filter) {
      this.filter_site_address_missing = filter;
      this.page = 1;
      this.filter();
    },
    filterSiteCityMissing(filter) {
      this.filter_site_city_missing = filter;
      this.page = 1;
      this.filter();
    },
    filterSiteProvinceMissing(filter) {
      this.filter_site_province_missing = filter;
      this.page = 1;
      this.filter();
    },
    filterPostalCodeMissing(filter) {
      this.filter_postal_code_missing = filter;
      this.page = 1;
      this.filter();
    },
    filterRouteGroupMissing(filter) {
      this.filter_route_group_missing = filter;
      this.page = 1;
      this.filter();
    },
    filterRouteNumberMissing(filter) {
      this.filter_route_number_missing = filter;
      this.page = 1;
      this.filter();
    },
    filterProjectOnHold(filter) {
      this.filter_project_on_hold_missing = filter;
      this.page = 1;
      this.filter();
    },
    filterNoticeContactMissing(filter) {
      this.filter_notice_contact_missing = filter;
      this.page = 1;
      this.filter();
    },
    filterMailingAddressMissing(filter) {
      this.filter_notice_contact_missing = filter;
      this.page = 1;
      this.filter();
    },
    filterEmailAddressMissing(filter) {
      this.filter_email_address_missing = filter;
      this.page = 1;
      this.filter();
    },
    filterNoticesContactArchive(filter) {
      this.filter_notices_contact_archive = filter;
      this.page = 1;
      this.filter();
    },
    filterNoticesContactOnHold(filter) {
      this.filter_notices_contact_archive = filter;
      this.page = 1;
      this.filter();
    },
    filterBillingContactMissing(filter) {
      this.filter_billing_contact_missing = filter;
      this.page = 1;
      this.filter();
    },
    filterBillingAddressMissing(filter) {
      this.filter_billing_address_missing = filter;
      this.page = 1;
      this.filter();
    },
    filterBillingCityMissing(filter) {
      this.filter_billing_city_missing = filter;
      this.page = 1;
      this.filter();
    },
    filterBillingProvinceMissing(filter) {
      this.filter_billing_province_missing = filter;
      this.page = 1;
      this.filter();
    },
    filterBillingPostalMissing(filter) {
      this.filter_billing_postal_missing = filter;
      this.page = 1;
      this.filter();
    },
    filterBillingContactArchived(filter) {
      this.filter_billing_contact_archived = filter;
      this.page = 1;
      this.filter();
    },
    filterBillingContactOnHold(filter) {
      this.filter_billing_contact_on_hold = filter;
      this.page = 1;
      this.filter();
    },
    filterSearch() {
      if (this.search === "") {
        this.filter_search = false;
      }
      else {
        this.page = 1;
        this.filter_search = true;
      }
      this.filter();
    },
    openProject(proj) {
      const link = document.createElement('a')
      const invURL = this.$router.resolve({ name: 'SnowOverview', params: { id: proj.id } })
      link.target = '_blank'
      link.href = invURL.href
      link.click()
    },
    viewStagingProject(staging_project) {
      this.$emit('viewStagingProject', staging_project);
    },
    async processSelected() {
      if (this.processing) {
        return;
      }
      this.processing = true;
      const returned_projects = await stagingAPI.advanceStaging(this.selected_projects, this.$store.state.auth.profile.id);
      this.$emit('updateStagingProject', returned_projects);
      this.deselectAll();
      this.processing = false;
    },
    toggleSelected() {
      if (this.selected_projects.length === this.staging_projects.length) {
        this.deselectAll();
      } else {
        this.selectAll();
      }
    },
    selectAll() {
      this.selected_projects = [];
      this.staging_projects.map((staging_project, index) => {
        if (staging_project.has_conflicts === false && staging_project.has_serious_conflicts === false && staging_project.resolved === false) {
          this.selected_projects.push(staging_project.id);
          const ref_name = "row" + index;
          this.$refs[ref_name][0].selectRow();
        }
      });
    },
    deselectAll() {
      for (let i = 0; i < this.staging_projects.length; i++) {
        const ref_name = "row" + i;
        this.$refs[ref_name][0].deselectRow();
      }
      this.selected_projects = [];
    },
    selectRow(id, select) {
      if (select) {
        this.selected_projects.push(id);
      }
      else {
        const index = this.selected_projects.indexOf(id);
        this.selected_projects.splice(index, 1);
      }
    },
    changePage(page) {
      this.deselectAll();
      this.page = page;
      this.selected_projects = [];
      this.$emit('filter', page, this.get_filters);
    }
  },
  components: {
    'staging-row': Row,
    'staging-table-header': Header
  }
}
</script>
<style>
.override-class .v-input {
  width: 100px;
}
</style>
